/* Mobile navigation */
(function () {
    const navigation = document.querySelector('.axit-navigation');
    const toggle = navigation && navigation.querySelector('.axit-menu-toggle');
    if (!navigation || !toggle) return;

    function setMenu(open) {
        navigation.classList.toggle('is-open', open);
        document.body.classList.toggle('menu-open', open);
        toggle.setAttribute('aria-expanded', String(open));
    }

    toggle.addEventListener('click', function () {
        setMenu(!navigation.classList.contains('is-open'));
    });

    navigation.querySelectorAll('.axit-menu a').forEach(function (link) {
        link.addEventListener('click', function () {
            setMenu(false);
        });
    });
})();

/* Report table of contents */
(function () {
    const report = document.querySelector('.axit-report-body');
    const toc = document.querySelector('.axit-report-toc');
    if (!report || !toc) return;

    const wordCount = report.textContent.trim().split(/\s+/).filter(Boolean).length;
    const headings = Array.from(report.querySelectorAll('h2, h3'));
    if (wordCount < 2000 || headings.length < 2) return;

    const list = document.createDocumentFragment();
    headings.forEach(function (heading, index) {
        if (!heading.id) heading.id = 'section-' + (index + 1);
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        if (heading.tagName === 'H3') link.classList.add('is-subhead');
        list.appendChild(link);
    });

    toc.querySelector('nav').appendChild(list);
    toc.hidden = false;
})();

/* Private #version-x-y tags become report metadata */
(function () {
    const versionMeta = document.querySelector('.axit-version-meta');
    if (!versionMeta) return;

    const version = Array.from(versionMeta.querySelectorAll('.axit-version')).find(function (item) {
        return item.dataset.version.indexOf('hash-version-') === 0;
    });
    if (!version) return;

    version.textContent = version.dataset.version.replace('hash-version-', '').replace(/-/g, '.');
    versionMeta.hidden = false;
})();

/* Copy the generated suggested citation */
(function () {
    const button = document.querySelector('.axit-copy-citation');
    const citation = document.querySelector('.axit-citation > p:last-child');
    if (!button || !citation || !navigator.clipboard) return;

    button.addEventListener('click', function () {
        navigator.clipboard.writeText(citation.textContent.trim()).then(function () {
            const original = button.textContent;
            button.textContent = 'Copied';
            window.setTimeout(function () {
                button.textContent = original;
            }, 1800);
        });
    });
})();

/* Keep wide research tables usable on smaller screens */
(function () {
    document.querySelectorAll('.gh-content > table:not(.gist table)').forEach(function (table) {
        if (table.parentElement.classList.contains('gh-table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
